// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"e_6-","imageUI":"e_7-","badgeContainer":"e_8-","badgeImage":"e_9-","container":"e_--"};